// Core Business Capital brand palette, sampled from logo-ob.jpg,
// corebusinesscapital.com and app.corebusinesscapital.com.
export const BRAND = {
  copperDark: '#AC682E',
  copper: '#BE7D37',
  copperLight: '#D19240',
  sand: '#E8BD76',
  brown: '#48270F',
  brownDeep: '#2E1808',
  gradient: 'linear-gradient(90deg, #AC682E 0%, #D19240 100%)',
  gradientHover: 'linear-gradient(90deg, #9A5C27 0%, #BE7D37 100%)',
  heroGradient: 'linear-gradient(135deg, #2E1808 0%, #48270F 55%, #5A3214 100%)',
  ink: '#1A1A1A',
  body: '#4B5563',
  muted: '#6B7280',
  border: '#E5E7EB',
  surface: '#F7F6F3',
  success: '#22A06B',
};

export const SUPPORT_PHONE = '720-222-3396';
export const SUPPORT_EMAIL = 'support@corebusinesscapital.com';
export const MAIN_SITE_URL = 'https://www.corebusinesscapital.com';
